import { LinkExternalIcon } from '@primer/octicons-react';
import * as React from 'react';
export default {
  LinkExternalIcon,
  React
};